// import { useCallback, useEffect, useMemo, useState } from "react";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faPlay } from '@fortawesome/free-solid-svg-icons';
// import Slider from "react-slick";
// import { BaseUrl } from "../helper/BaseUrl";
// import { ApiEndpoints } from "../helper/ApiEndpoints";
// import ApiRequest from "../helper/ApiRequest";

// const testimonialListEndpoint = ApiEndpoints.VideoTestimonial.testimonialView;

// export default function HomeTestimonial({ headText }) {
//   const [isPopupVisible, setPopupVisible] = useState(false);
//   const [currentVideo, setCurrentVideo] = useState("");
//   const [data, setData] = useState([]);

//   const dataFetch = useCallback(async () => {
//     try {
//       const response = await ApiRequest("GET", testimonialListEndpoint);
//       const result = response.video_testimonials;
//       setData(result);
//     } catch (error) {
//       console.error(error);
//     }
//   }, []);


//   useEffect(() => {
//     dataFetch();
//   }, [dataFetch]);

//   const settings = useMemo(
//     () => ({
//       dots: true,
//       arrows: false,
//       infinite: true,
//       speed: 1500,
//       autoplaySpeed: 3500,
//       slidesToShow: 2,
//       slidesToScroll: 2,
//       autoplay: true,
//       pauseOnHover: true,
//       cssEase: "ease",
//       responsive: [
//         {
//           breakpoint: 992,
//           settings: {
//             slidesToShow: 1,
//             slidesToScroll: 1,
//             infinite: true,
//             centerMode: false,
//           },
//         },
//       ],
//     }),
//     []
//   );

//   const openPopup = useCallback((videoSrc) => {
//     const url = videoSrc.includes("?")
//       ? `${videoSrc}&autoplay=1`
//       : `${videoSrc}?autoplay=1`;
//     setCurrentVideo(url);
//     setPopupVisible(true);
//   }, []);

//   const closePopup = useCallback(() => {
//     setPopupVisible(false);
//     setCurrentVideo("");
//   }, []);
  
//   return (
//     <>
//       <div className="home-testimonial">
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-12">
//               <h2 className="heading center-heading">{headText}</h2>

//               <Slider className="testimonial-slider youtube-slider" {...settings}>
//                 {data && data.map((item, index) => (
//                   <div key={index} className="youtube-testimonial" onClick={() => openPopup(`${item.url}`)}>
//                     <div className="yout-test-wrap">
//                       <img loading="lazy" src={`${BaseUrl}${item.thumbnail}`} alt="video" className="img-responsive" />
//                       <span className="play-butn"><FontAwesomeIcon icon={faPlay} /></span>
//                     </div>
//                     <span><img loading="lazy" src="/assets/home/youtube-testimonial-logo.webp" alt="logo" className="img-responsive" /></span>
//                   </div>
//                 ))}
//               </Slider>
//             </div>
//           </div>
//         </div>
//       </div>

//       {isPopupVisible && (
//         <div className="tube-test-video-popup">
//           <div className="tube-test-popup-overlay" onClick={closePopup}></div>
//           <div className="tube-test-popup-content">
//             <button className="tube-test-close-btn" onClick={closePopup}>
//               ✖
//             </button>
//             <iframe
//               src={currentVideo}
//               title="YouTube video player"
//               allow="autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//               allowFullScreen
//             ></iframe>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

import React, { memo, useCallback, useEffect, useMemo, useState} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { BaseUrl } from "../helper/BaseUrl";
import { ApiEndpoints } from "../helper/ApiEndpoints";
import ApiRequest from "../helper/ApiRequest";
import Slider from "react-slick";

const testimonialListEndpoint = ApiEndpoints.VideoTestimonial.testimonialView;
const asList = (value) => (Array.isArray(value) ? value : []);

const HomeTestimonial = memo(function HomeTestimonial({ headText, initialData }) {
  const [isPopupVisible, setPopupVisible] = useState(false);
  const [currentVideo, setCurrentVideo] = useState("");
  const [data, setData] = useState(() => asList(initialData));

  /* =====================
     API FETCH (ONCE)
  ======================== */
  const dataFetch = useCallback(async () => {
    try {
      const response = await ApiRequest("GET", testimonialListEndpoint);
      setData(asList(response?.video_testimonials));
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    if (data.length) return;
    dataFetch();
  }, [data.length, dataFetch]);

  /* =======================
     SLIDER SETTINGS (MEMO)
  ======================= */
  const settings = useMemo(
    () => ({
      dots: true,
      arrows: false,
      infinite: true,
      speed: 1500,
      autoplaySpeed: 3500,
      slidesToShow: 2,
      slidesToScroll: 2,
      autoplay: true,
      pauseOnHover: true,
      cssEase: "ease",
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    }),
    []
  );

  /* =======================
     POPUP HANDLERS
  ======================= */
  const openPopup = useCallback((videoSrc) => {
    const url = videoSrc.includes("?")
      ? `${videoSrc}&autoplay=1`
      : `${videoSrc}?autoplay=1`;

    setCurrentVideo(url);
    setPopupVisible(true);
  }, []);

  const closePopup = useCallback(() => {
    setPopupVisible(false);
    setCurrentVideo("");
  }, []);

  /* =======================
     SLIDER JSX (MEMO)
  ======================= */
  const sliderContent = useMemo(() => {
    if (!data.length) return null;

    return (

        <Slider
          className="testimonial-slider youtube-slider"
          {...settings}
        >
          {data.map((item) => (
            <div
              key={item.id || item._id}
              className="youtube-testimonial"
              onClick={() => openPopup(item.url)}
            >
              <div className="yout-test-wrap">
                <img
                  loading="lazy"
                  src={`${BaseUrl}${item.thumbnail}`}
                  alt="video testimonial"
                  className="img-responsive"
                />
                <span className="play-butn">
                  <FontAwesomeIcon icon={faPlay} />
                </span>
              </div>

              <span>
                <img
                  loading="lazy"
                  src="/assets/home/youtube-testimonial-logo.webp"
                  alt="youtube"
                  className="img-responsive"
                />
              </span>
            </div>
          ))}
        </Slider>
    );
  }, [data, settings, openPopup]);

  return (
    <>
      <div className="home-testimonial">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h2 className="heading center-heading">{headText}</h2>
              {sliderContent}
            </div>
          </div>
        </div>
      </div>

      {/* =======================
          VIDEO POPUP
      ======================= */}
      {isPopupVisible && (
        <div className="tube-test-video-popup">
          <div
            className="tube-test-popup-overlay"
            onClick={closePopup}
          />
          <div className="tube-test-popup-content">
            <button
              className="tube-test-close-btn"
              onClick={closePopup}
            >
              ✖
            </button>

            <iframe
              src={currentVideo}
              title="YouTube video"
              allow="autoplay; encrypted-media; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      )}
    </>
  );
});

export default HomeTestimonial;
